const swiper_reviews_carousel = new Swiper('.reviews_carousel', {
    spaceBetween: 30,
    loop: true,
    autoHeight: true,
    navigation: {
        nextEl: '.reviews_carousel_next',
        prevEl: '.reviews_carousel_prev',
    },
    on: {
        init(swiper) {
            updateAriaHidden(swiper);
        },
        slideChange(swiper) {
            updateAriaHidden(swiper);
        },
    }
});
